"use strict";

var _interopRequireDefault = require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/follow-book_follow-book-admin_fMUT/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _Edit = _interopRequireDefault(require("../../components/Book/Edit.vue"));

var _followBook = require("../../api/followBook");

var _collection = require("../../utils/collection");

//
//
//
//
//
//
//
//
var _default = {
  name: 'BookCreate',
  components: {
    BookEdit: _Edit.default
  },
  data: function data() {
    return {
      loading: false,
      data: {
        // 图书信息
        title: undefined,
        sectionCode: undefined,
        subjectCode: undefined,
        gradeCode: undefined,
        editionCode: undefined,
        volumeCode: undefined,
        periodCode: undefined,
        followUpBookType: '课内',
        category: undefined,
        state: 1
      }
    };
  },
  computed: {
    bookListStyle: function bookListStyle() {
      return {
        height: "".concat(this.$store.state.app.availableHeight, "px")
      };
    } // 控制页面高度

  },
  methods: {
    onSubmit: function () {
      var _onSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 保存图书
                this.loading = true;
                _context.prev = 1;
                data = (0, _collection.strictTrim)(this.data, ['title', 'category']); // 如果标题和分类是无效的字符串，设置为 undefined

                if (data.followUpBookType === '课内') {
                  data.category = '';
                } // 课内书没有分类


                _context.next = 6;
                return (0, _followBook.createBook)(data);

              case 6:
                this.$router.back();
                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);
                message = _context.t0.message;
                this.$notify.error({
                  title: '错误',
                  message: message
                });

              case 13:
                _context.prev = 13;
                this.loading = false;
                return _context.finish(13);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 9, 13, 16]]);
      }));

      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }(),
    goBack: function goBack() {
      this.$router.back();
    }
  }
};
exports.default = _default;